module.exports = __webpack_public_path__ + "static/media/super-hit.2d74141b.png";